import en from './locales/en.json';
import fr from './locales/fr.json';

export const locales = { en, fr };
export const SUPPORTED = ['en', 'fr'];
export const DEFAULT_LANG = 'en';

export const getLocale = (lang) => locales[lang] || locales[DEFAULT_LANG];

// Language display names used in the language switcher / banner
export const LANG_NAMES = { en: 'English', fr: 'Français' };
